import { render } from "./extreme.vue?vue&type=template&id=be73bbc6"
import script from "./extreme.vue?vue&type=script&lang=js"
export * from "./extreme.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__